import clsx from "clsx";
import Image from "next/image";

import rotateIcon from "@/assets/icons/rotate.svg";

type Props = {
  rotateAnimation: boolean;
  handleRotateDegrees: (mediaIndex: number) => void;
  handleRotateAnimation: () => void;
  mediaIndex: number;
};

const RotateButton = ({
  rotateAnimation,
  handleRotateDegrees,
  handleRotateAnimation,
  mediaIndex
}: Props) => {
  return (
    <button
      className={clsx(
        "flex items-center justify-center rounded-full bg-[#232323] opacity-60 active:scale-105",
        rotateAnimation && "animate-spin-reverse"
      )}
      onClick={(e) => {
        handleRotateDegrees(mediaIndex);
        handleRotateAnimation();
        e.stopPropagation();
      }}
      disabled={rotateAnimation}
    >
      <Image
        src={rotateIcon}
        alt=""
        width={26}
        height={29}
        className="pb-[0.3rem]"
      />
    </button>
  );
};

export default RotateButton;
